import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpUtilsService, QueryParamsModel, QueryResultsModel } from '../../_base/crud';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { currentAuthToken, currentUser } from '../../auth';
import { environment } from 'src/environments/environment';

@Injectable()
export class TagService {
  private authToken;
  private company_id;

  constructor(
    private http: HttpClient,
    private httpUtils: HttpUtilsService,
    private store: Store<AppState>,
  ) {
    this.store.pipe(select(currentAuthToken)).subscribe((res) => (this.authToken = res));
    this.store.pipe(select(currentUser)).subscribe((res) => (this.company_id = res.companyID));
  }

  createTag(body) {
    const url = `${environment.CORE_BASE}/companies/${this.company_id}/tags`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.post<any>(url, body, { headers });
  }

  findTags(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
    const url = `${environment.CORE_BASE}/companies/${this.company_id}/tags`;
    const params = new HttpParams({
      fromString: TagService.getTagsListQueryString(queryParams),
    });
    return this.http.get<QueryResultsModel>(url, { params });
  }

  private static getTagsListQueryString(queryParams: QueryParamsModel): string {
    const { pageNumber, pageSize, sortField, sortOrder, filter } = queryParams;
    let fromString = `page=${pageNumber}&size=${pageSize}&sort=${sortField},${sortOrder}`;

    if (filter.searchTerm) {
      fromString += `&search_term=${filter.searchTerm}`;
    } else {
      if (filter.name) fromString += `&name_has=${filter.name}`;
      if (filter.type) fromString += `&entity_has=${filter.type}`;
      if (filter.frequency) fromString += `&frequency_has=${filter.frequency}`;
    }

    return fromString;
  }
}
